import { useEffect, useRef, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { CheckCircle2, XCircle, Loader2 } from "lucide-react";
import { verifyPayment, payfastStatus } from "../lib/api";

const sleep = (ms) => new Promise((r) => setTimeout(r, ms));

async function pollPayfast(reference) {
  for (let i = 0; i < 15; i += 1) {
    const d = await payfastStatus(reference);
    if (d.status !== "processing") return d;
    await sleep(2000);
  }
  return { status: "processing" };
}

export default function PaymentCallback() {
  const [params] = useSearchParams();
  const reference = params.get("reference") || params.get("trxref");
  const isPayfast = params.get("provider") === "payfast";
  const cancelled = params.get("cancelled") === "1";
  const [state, setState] = useState(reference && !cancelled ? "checking" : "failed");
  const [trial, setTrial] = useState(false);
  const [school, setSchool] = useState(false);
  const done = useRef(false);

  useEffect(() => {
    if (!reference || cancelled || done.current) return;
    done.current = true;
    (isPayfast ? pollPayfast(reference) : verifyPayment(reference))
      .then((d) => {
        setTrial(!!d.trial);
        setSchool(d.purpose === "school");
        setState(d.status === "success" ? "success" : d.status === "processing" ? "pending" : "failed");
        if (d.status === "success") setTimeout(() => { window.location.href = d.purpose === "school" ? "/school" : "/"; }, 1800);
      })
      .catch(() => setState("failed"));
  }, [reference, isPayfast, cancelled]);

  return (
    <div className="what-app h-screen grid place-items-center px-6">
      <div data-testid="payment-callback" className="text-center max-w-sm what-rise">
        {state === "pending" && (
          <>
            <Loader2 size={32} className="text-[#D4FF3A] mx-auto" />
            <h1 data-testid="payment-status" className="font-display text-2xl font-bold text-white mt-4">Payment received, still confirming</h1>
            <p className="text-slate-400 mt-2">PayFast is confirming your payment. Your plan will switch on within a few minutes.</p>
            <Link to="/" data-testid="payment-back-btn" className="what-btn-primary mt-6 inline-flex">Back to WHAT?</Link>
          </>
        )}
        {state === "checking" && (
          <>
            <Loader2 size={32} className="animate-spin text-[#D4FF3A] mx-auto" />
            <p data-testid="payment-status" className="mt-4 text-slate-300">Confirming your payment…</p>
          </>
        )}
        {state === "success" && (
          <>
            <CheckCircle2 size={40} className="text-[#D4FF3A] mx-auto" />
            <h1 data-testid="payment-status" className="font-display text-2xl font-bold text-white mt-4">
              {school ? "Your class subscription is active" : trial ? "Your 14-day free trial has started" : "Welcome to WHAT? Pro"}
            </h1>
            <p className="text-slate-400 mt-2">All three AIs are unlocked. Taking you back…</p>
          </>
        )}
        {state === "failed" && (
          <>
            <XCircle size={40} className="text-red-400 mx-auto" />
            <h1 data-testid="payment-status" className="font-display text-2xl font-bold text-white mt-4">Payment not completed</h1>
            <p className="text-slate-400 mt-2">You haven't been charged for Pro. You can try again any time.</p>
            <Link to="/" data-testid="payment-back-btn" className="what-btn-primary mt-6 inline-flex">Back to WHAT?</Link>
          </>
        )}
      </div>
    </div>
  );
}
